import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export type ConnectionStatuses =
    | ''
    | 'connecting'
    | 'connection-failed'
    | 'connected'
    | 'logged-in'
    | 'logged-out'
    | 'forbidden'
    | 'registered';

export interface UserInfoState {
    token: string;
    status: ConnectionStatuses;
    userName: string;
    uniqueId: string;
    displayName: string;
}

const initialState: UserInfoState = {
    token: '',
    status: '',
    userName: '',
    uniqueId: '',
    displayName: '',
};

const userInfoSlice = createSlice({
    name: 'userInfo',
    initialState,
    reducers: {
        init: (state, action: PayloadAction<UserInfoState>) => {
            state.token = action.payload.token;
            state.status = action.payload.status;
            state.userName = action.payload.userName;
            state.uniqueId = action.payload.uniqueId;
            state.displayName = action.payload.displayName;
        },

        setStatus: (state, action: PayloadAction<ConnectionStatuses>) => {
            state.status = action.payload;
        },
    },
});

const actions = userInfoSlice.actions;
export const userInfoActions = {
    init: actions.init,
    setStatus: actions.setStatus,
};
export const userInfoReducer = userInfoSlice.reducer;
